var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 17.242a.442.442 0 01-.442-.442V5.305a.442.442 0 11.884 0V16.8a.442.442 0 01-.442.442M5.747 17.242a.442.442 0 01-.44-.408L4.422 5.339a.442.442 0 11.882-.068l.884 11.495a.442.442 0 01-.441.476M11.053 17.242a.442.442 0 01-.441-.476l.884-11.495a.442.442 0 11.882.068l-.885 11.495a.442.442 0 01-.44.408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.511 19.895H4.29c-.908 0-1.664-.68-1.76-1.583L.888 2.699a.442.442 0 11.879-.092L3.41 18.219c.047.451.425.792.879.792h8.222c.454 0 .832-.34.88-.792l1.643-15.612a.442.442 0 11.88.092L14.27 18.312a1.764 1.764 0 01-1.759 1.583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.358 3.095H.442a.442.442 0 110-.884h15.916a.442.442 0 110 .884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.937 2.653a.442.442 0 01-.442-.442v-.885a.443.443 0 00-.442-.442H5.747a.443.443 0 00-.442.442v.885a.442.442 0 11-.884 0v-.885C4.421.596 5.016 0 5.747 0h5.306c.73 0 1.326.595 1.326 1.326v.885a.442.442 0 01-.442.442"
  }))));
}
export default SvgTrash;